export default {
  presets: {
    light: {
      primary: '#0E1026',
      backgroundPrimary: '#FFFFFF',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#F7F9F9',
      backgroundCardSecondary: '#ECFDE6',
      success: '#2DF1D0',
      info: '#a25afc',
      danger: '#FF5050',
      warning: '#FFDE07',
      textPrimary: '#0E1026',
      light: '#ECFDE6',
    },
    dark: {
      backgroundCardPrimary: '#111827',
      backgroundCardSecondary: '#0f172a',
    },
  },
}
